import React from "react";
import MenuItem from "@mui/material/MenuItem";
import { downloadAuthenticatedFile } from "utils/download-file";
import { userLoginToken } from "utils/general-utils";

type Props = {
  interestID: string;
  onClick?: () => void;
}

/** Slideout printable PDF — not HelloSign; includes position, status, linked account. */
const PrintableDownload: React.FC<Props> = ({ interestID, onClick }) => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const onDownload = async () => {
    onClick?.();
    setIsDownloading(true);
    try {
      const fileName = await downloadAuthenticatedFile(
        `/api/interests/${interestID}/printable-pdf`,
        {
          headers: { authorization: `Bearer ${userLoginToken()}` },
          fallbackFilename: `application-${Date.now()}.pdf`,
        },
      );
      setTimeout(() => alert(`Saving ${fileName} to your downloads folder.`), 200);
    } catch (error) {
      if (error instanceof Error && error.message === "not_found") {
        alert("File not found.");
      } else {
        alert("Error downloading PDF file");
      }
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <MenuItem
      id="slideout-print"
      onClick={onDownload}
      disabled={isDownloading}
    >
      {isDownloading ? "Downloading..." : "Print"}
    </MenuItem>
  );
};

export default PrintableDownload;
